import { TRANSPORT_URL } from "./config";
import { bus } from "@/main.js";
import * as io from "socket.io-client";

class Transport {
    constructor() {}

    init() {
        this.socket = io(TRANSPORT_URL, {
            query: {
                token: localStorage.getItem("token"),
                identity: JSON.stringify({
                    domain: "admin",
                    device: "web"
                })
            }
        });
        this.socket.on("connect", () => {
            console.log(`Transport connected on ${TRANSPORT_URL}`);
            this.socket.on("action", payload => {
                console.log("Transport payload", payload);
                this.registerActions(payload);
            });
        });
        this.socket.on("disconnect", reason => {
            if (reason === "io server disconnect") {
                console.log("Disconnected from Transport server");
            } else {
                console.log("Transport Disconnected", reason);
            }
            this.socket.off("action");
        });
    }

    registerActions(payload) {
        bus.$emit(payload.type, payload);
    }
}

export default new Transport();